export default __webpack_public_path__ + "static/media/080_finish_bad.last.5e56c28c.png";